module.exports = __webpack_public_path__ + "static/SEAlogo-539847dc751328a9979548bc2c06cc58.svg";